/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AdminAgentBorrowingRange from './AdminAgentBorrowingRange';

/**
 * The AdminAgentTargetConditionPayload model module.
 * @module model/AdminAgentTargetConditionPayload
 * @version 1.0.0
 */
class AdminAgentTargetConditionPayload {
    /**
     * Constructs a new <code>AdminAgentTargetConditionPayload</code>.
     * @alias module:model/AdminAgentTargetConditionPayload
     */
    constructor() { 
        
        AdminAgentTargetConditionPayload.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AdminAgentTargetConditionPayload</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AdminAgentTargetConditionPayload} obj Optional instance to populate.
     * @return {module:model/AdminAgentTargetConditionPayload} The populated <code>AdminAgentTargetConditionPayload</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AdminAgentTargetConditionPayload();

            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'Number');
            }
            if (data.hasOwnProperty('age_min')) {
                obj['age_min'] = ApiClient.convertToType(data['age_min'], 'Number');
            }
            if (data.hasOwnProperty('age_max')) {
                obj['age_max'] = ApiClient.convertToType(data['age_max'], 'Number');
            }
            if (data.hasOwnProperty('annual_income_min')) {
                obj['annual_income_min'] = ApiClient.convertToType(data['annual_income_min'], 'Number');
            }
            if (data.hasOwnProperty('annual_income_max')) {
                obj['annual_income_max'] = ApiClient.convertToType(data['annual_income_max'], 'Number');
            }
            if (data.hasOwnProperty('work_experience_years')) {
                obj['work_experience_years'] = ApiClient.convertToType(data['work_experience_years'], ['String']);
            }
            if (data.hasOwnProperty('job_categories')) {
                obj['job_categories'] = ApiClient.convertToType(data['job_categories'], ['String']);
            }
            if (data.hasOwnProperty('job_industries')) {
                obj['job_industries'] = ApiClient.convertToType(data['job_industries'], ['String']);
            }
            if (data.hasOwnProperty('free_note')) {
                obj['free_note'] = ApiClient.convertToType(data['free_note'], 'String');
            }
            if (data.hasOwnProperty('borrowing_ranges')) {
                obj['borrowing_ranges'] = ApiClient.convertToType(data['borrowing_ranges'], [AdminAgentBorrowingRange]);
            }
            if (data.hasOwnProperty('residence_prefectures')) {
                obj['residence_prefectures'] = ApiClient.convertToType(data['residence_prefectures'], ['String']);
            }
            if (data.hasOwnProperty('financial_asset_ids')) {
                obj['financial_asset_ids'] = ApiClient.convertToType(data['financial_asset_ids'], ['Number']);
            }
            if (data.hasOwnProperty('investment_property_count_min')) {
                obj['investment_property_count_min'] = ApiClient.convertToType(data['investment_property_count_min'], 'Number');
            }
            if (data.hasOwnProperty('investment_property_count_max')) {
                obj['investment_property_count_max'] = ApiClient.convertToType(data['investment_property_count_max'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AdminAgentTargetConditionPayload</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AdminAgentTargetConditionPayload</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['work_experience_years'])) {
            throw new Error("Expected the field `work_experience_years` to be an array in the JSON data but got " + data['work_experience_years']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['job_categories'])) {
            throw new Error("Expected the field `job_categories` to be an array in the JSON data but got " + data['job_categories']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['job_industries'])) {
            throw new Error("Expected the field `job_industries` to be an array in the JSON data but got " + data['job_industries']);
        }
        // ensure the json data is a string
        if (data['free_note'] && !(typeof data['free_note'] === 'string' || data['free_note'] instanceof String)) {
            throw new Error("Expected the field `free_note` to be a primitive type in the JSON string but got " + data['free_note']);
        }
        if (data['borrowing_ranges']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['borrowing_ranges'])) {
                throw new Error("Expected the field `borrowing_ranges` to be an array in the JSON data but got " + data['borrowing_ranges']);
            }
            // validate the optional field `borrowing_ranges` (array)
            for (const item of data['borrowing_ranges']) {
                AdminAgentBorrowingRange.validateJSON(item);
            };
        }
        // ensure the json data is an array
        if (!Array.isArray(data['residence_prefectures'])) {
            throw new Error("Expected the field `residence_prefectures` to be an array in the JSON data but got " + data['residence_prefectures']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['financial_asset_ids'])) {
            throw new Error("Expected the field `financial_asset_ids` to be an array in the JSON data but got " + data['financial_asset_ids']);
        }

        return true;
    }


}



/**
 * @member {Number} version
 */
AdminAgentTargetConditionPayload.prototype['version'] = undefined;

/**
 * @member {Number} age_min
 */
AdminAgentTargetConditionPayload.prototype['age_min'] = undefined;

/**
 * @member {Number} age_max
 */
AdminAgentTargetConditionPayload.prototype['age_max'] = undefined;

/**
 * @member {Number} annual_income_min
 */
AdminAgentTargetConditionPayload.prototype['annual_income_min'] = undefined;

/**
 * @member {Number} annual_income_max
 */
AdminAgentTargetConditionPayload.prototype['annual_income_max'] = undefined;

/**
 * @member {Array.<String>} work_experience_years
 */
AdminAgentTargetConditionPayload.prototype['work_experience_years'] = undefined;

/**
 * @member {Array.<String>} job_categories
 */
AdminAgentTargetConditionPayload.prototype['job_categories'] = undefined;

/**
 * @member {Array.<String>} job_industries
 */
AdminAgentTargetConditionPayload.prototype['job_industries'] = undefined;

/**
 * @member {String} free_note
 */
AdminAgentTargetConditionPayload.prototype['free_note'] = undefined;

/**
 * @member {Array.<module:model/AdminAgentBorrowingRange>} borrowing_ranges
 */
AdminAgentTargetConditionPayload.prototype['borrowing_ranges'] = undefined;

/**
 * @member {Array.<String>} residence_prefectures
 */
AdminAgentTargetConditionPayload.prototype['residence_prefectures'] = undefined;

/**
 * @member {Array.<Number>} financial_asset_ids
 */
AdminAgentTargetConditionPayload.prototype['financial_asset_ids'] = undefined;

/**
 * @member {Number} investment_property_count_min
 */
AdminAgentTargetConditionPayload.prototype['investment_property_count_min'] = undefined;

/**
 * @member {Number} investment_property_count_max
 */
AdminAgentTargetConditionPayload.prototype['investment_property_count_max'] = undefined;






export default AdminAgentTargetConditionPayload;

